export class Landkreis {
    landkreis_id: number;
    bezeichnung: string;
    bundesland: string;
    lieferant_id_ueberwachungsbehoerde: number;
    lieferant_id_veterinaeramt: number;
    ueberwachungsbehoerde: string;
    veterinaeramt: string;
}
